// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".default .chat-minimized{overflow:auto}.default .chat-minimized .header .title{min-width:145px}", ""]);
// Exports
module.exports = exports;
